module.exports = __webpack_public_path__ + "static/media/Ex3-S1.b248be8d.PNG";